import { MaterialUICore } from '@iclinic/design-system';

export const useStyles = MaterialUICore.makeStyles({
  image: {
    margin: 'auto',
  },
});
